if(!customElements.get('product-multicolumn')) {
  // 注册自定义元素
  customElements.define("product-multicolumn", class ProductMulticolumn extends HTMLElement {
    constructor() {
      super();
      // 初始化元素的状态或属性
      this.data = {
        pcCount: parseInt(this.querySelector('.custom-multicolumn-wrapper').getAttribute('data-pccolumns')),
        padCount: parseInt(this.querySelector('.custom-multicolumn-wrapper').getAttribute('data-padcolumns')),
        mbCount: parseInt(this.querySelector('.custom-multicolumn-wrapper').getAttribute('data-mbcolumns'))
      }
    }
  
    connectedCallback() {
      // 元素被添加到DOM时调用
      // 初始化元素
      this.init();
      // 添加 resize 事件监听器
      this.resizeListener = this.debounce(this.handleResize.bind(this), 200);
      window.addEventListener('resize', this.resizeListener);
    }
  
    disconnectedCallback() {
      // 元素从DOM中移除时调用
      // 移除 slick 实例
      this.destroySlick(multicolumnList);
      // 移除 resize 事件监听器
      window.removeEventListener('resize', this.resizeListener);
    }
  
    init() {
      document.addEventListener('DOMContentLoaded', () => {
        this.handleResize(); // 初始化时也执行一次 handleResize
      });
    }
  
    handleResize() {
      const multicolumnList = $(this.querySelector('.custom-multicolumn-list'));
      this.initSlick(multicolumnList);
    }
  
    initSlick(multicolumnList) {
      if (multicolumnList.hasClass('slick-initialized')) {
        multicolumnList.slick('unslick');
      }
      multicolumnList.slick({
        infinite: true,
        draggable: true,
        slidesToShow: this.data.pcCount || 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="multicolumn-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="multicolumn-prev">Prev Item</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
        nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" role="img" aria-labelledby="multicolumn-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="multicolumn-next">Next Item</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
        responsive: [
          {
            breakpoint: 1000,
            settings: {
              slidesToShow: this.data.padCount || 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 590,
            settings: {
              slidesToShow: this.data.mbCount || 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  
    destroySlick(multicolumnList = $(this.querySelector('.custom-multicolumn-list'))) {
      if (multicolumnList.hasClass('slick-initialized')) {
        multicolumnList.slick('unslick');
      }
    }
  
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const later = () => {
          clearTimeout(timeout);
          func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  });
}
